import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[unhDialogRef]',
})
export class UnhDialogRefDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
